import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Head from 'next/head';
import { Accessibility, Eye, Heart } from 'lucide-react';
export default function AccessibilityPage() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><title>Accessibility Statement | Sizzle</title><meta name="description" content="Our commitment to making Sizzle accessible to everyone." /></Head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-white rounded-[3rem] p-12 mb-12 shadow-sm border border-gray-100 text-center"><div className="inline-flex w-20 h-20 bg-primary-100 rounded-[2rem] items-center justify-center text-primary-600 mb-8"><Accessibility className="w-10 h-10" /></div><h1 className="text-4xl font-black text-gray-900 mb-6">Accessibility at Sizzle</h1><p className="text-gray-600 text-lg max-w-2xl mx-auto">We believe discovery should be for everyone. We're committed to making Sizzle accessible and user-friendly for all members of our community.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-white p-10 rounded-[2.5rem] shadow-sm border border-gray-100"><div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-6"><Eye className="w-6 h-6" /></div><h3 className="text-xl font-bold text-gray-900 mb-4">Our Commitment</h3><p className="text-gray-600 leading-relaxed">We are working to ensure that our website and tools are accessible to people of all abilities. We follow the Web Content Accessibility Guidelines (WCAG) as a framework for our development.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">{t2}<div className="bg-white p-10 rounded-[2.5rem] shadow-sm border border-gray-100"><div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center text-green-600 mb-6"><Heart className="w-6 h-6" /></div><h3 className="text-xl font-bold text-gray-900 mb-4">Ongoing Work</h3><p className="text-gray-600 leading-relaxed">Accessibility is an ongoing journey. We regularly review our platform and implement improvements to navigation, readability, and compatibility with assistive technologies.</p></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="text-2xl font-bold text-gray-900 mb-6">Accessibility Features</h2>;
    t5 = <p>Some of the steps we've taken to improve accessibility include:</p>;
    t6 = <ul><li><strong>Descriptive Alt Text:</strong> Providing descriptions for product images.</li><li><strong>Keyboard Navigation:</strong> Ensuring interactive elements are reachable via keyboard.</li><li><strong>Color Contrast:</strong> Using colors that meet contrast requirements for readability.</li><li><strong>Semantic HTML:</strong> Implementing proper heading structures and ARIA labels.</li></ul>;
    t7 = <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">{"Feedback & Assistance"}</h2>;
    t8 = <p>If you encounter any difficulty using Sizzle, or have suggestions on how we can improve our accessibility, we want to hear from you.</p>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <>{t0}<div className="min-h-screen bg-gray-50 pt-32 pb-24"><div className="container mx-auto px-6"><div className="max-w-4xl mx-auto">{t1}{t3}<div className="bg-white rounded-[3rem] p-12 shadow-sm border border-gray-100 prose prose-gray max-w-none">{t4}{t5}{t6}{t7}{t8}<p>Please reach out to us at:<br /><a href="mailto:access@sizzle.nz" className="text-primary-600 font-bold no-underline hover:underline">access@sizzle.nz</a></p><p>We aim to respond to all feedback within 3 business days.</p></div></div></div></div></>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}